import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    account: { checkUserAndCompany: url },
  },
} = config

/**
 * Check if company or user is created
 * @param {Object} data.user User object containing its email
 * @param {Object} data.company Company related data
 */
export const check = (data) => axios.post(url, data, { headers: getHeaders(true) })

/**
 * Check if token is valid
 * @param {String} data.token Token to check
 * @param {Boolean} data.payment Is a payment token?
 */
export const checkToken = (data) =>
  axios.get(`${url}?token=${data.token}${data.payment ? '&payment=true' : ''}`, {
    headers: getHeaders(),
  })
